import React, {useState} from 'react';
import bannerlimena from '../assets/images/limena/PopUp_lateral.jpg';
import logolimena from '../assets/images/limena/logonobg.png';
import emailjs from '@emailjs/browser';
import catalogo from '../assets/catalog.pdf';


function PopupVideo({ videoSrc, handler }) {
    const apiKey = 'b259e58349f822955cfe6feeffeee0332200d24e5655c754b127716b9341f5ad7673226a';

    const [name, setName] = useState('');
    const [lastname, setLastName] = useState('');
    const [email, setEmail] = useState('');
    /* 
     //www.youtube.com/embed/EE7NqzhMDms?autoplay=1
    */

     function sendEmail(e) {
        console.log(email)
        console.log(lastname)
        console.log(name)

        if(name=="" || lastname=="" || email==""){
            alert("All field are required")
            return;
        }
        e.preventDefault();
        emailjs.sendForm('service_dm2oxqb', 'template_wunizha', e.target, 'user_4dM4z33kE4xbfbOAnHUdl')
        .then(async (result) => {
            console.log(result.text);
            
            const options = {
                method: 'POST',
                headers: {accept: 'application/json', 'content-type': 'application/json','Api-Token' : apiKey},
                body: JSON.stringify({
                  contact: {
                    email: email,
                    firstName: name,
                    lastName: lastname,
                    phone: '',
                   
                  }
                })
              };
            const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json','Api-Token' : apiKey
                     },
                    body: JSON.stringify({
                        "contact": {
                            "email": email,
                            "firstName": name,
                            "lastName": lastname,
                            "phone": ""
                        }
                    }),
                  };

                  try {
                    const response = await fetch('https://comerciamarketing.api-us1.com/api/3/contacts', options);
                    if (!response.ok) {
                        console.log("Error al crear contacto")

                      console.log(new Error(`HTTP error! status: ${response.status}`));
                      alert("Your message was successfully sent!")
                      window.location.reload(false); 
                      return
                    }
                    const data = await response.json();
                    console.log(data)
                    alert("Your message was successfully sent!")
                    window.location.reload(false); 


                  } catch (error) {
                    console.error('Error:', error);
                    alert("Your message was successfully sent!")
                    window.location.reload(false); 
                    //alert("Your message was successfully sent!")
                  }      
      
        }, (error) => {
            alert("Error to process the transaction, please try again")
            console.log(error.text);
        });

      }

    return (
        <div >
            <div onClick={handler} className="mfp-bg mfp-ready"></div>
            <div
                className="mfp-wrap mfp-close-btn-in mfp-auto-cursor mfp-ready"
                tabIndex="-1"
                style={{ overflow: 'hidden auto' }}
            >
                <div className="mfp-container mfp-s-ready mfp-iframe-holder">
                    <div className="mfp-content" style={{backgroundColor:'#fff', height:"100%"}}>
                        
                            <button
                                onClick={handler}
                                title="Close (Esc)"
                                type="button"
                                className="mfp-close"
                            >
                                ×
                            </button>
                            <object data={catalogo + "#toolbar=0&navpanes=0&scrollbar=0&statusbar=0&messages=0&scrollbar=0"} type="application/pdf" width="100%" height="100%">
   
   </object>
           

                      
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PopupVideo;
